import { useQuery } from '@tanstack/react-query';

import { authFetch } from '@verantos-dev/core-utils';
import type { ListResponse } from '@verantos-dev/types-common';

import type { AnalyticalVariableLookupItem } from './types';

interface UseAnalyticalVariableLookupQueryArgs {
  projectId: string;
}

/**
 * Lists the project's visible analytical variables via GET /analytical-variables,
 * the same lookup the analytical-dataset variables section joins its `avId`s
 * against.
 *
 * The key follows the analytical-variables library list key
 * (`['analytical-variables', 'library', searchParams, projectId]`), so this
 * query shares that cache entry and is invalidated whenever a variable is
 * edited. feature-analysis cannot import `avKeys` from
 * feature-analytical-variables (module-boundary cycle), hence the literal.
 */
export const useAnalyticalVariableLookupQuery = ({
  projectId,
}: UseAnalyticalVariableLookupQueryArgs) =>
  useQuery({
    queryKey: ['analytical-variables', 'library', undefined, projectId],
    queryFn: () =>
      authFetch<ListResponse<AnalyticalVariableLookupItem>>(
        `/analytical-variables?projectId=${encodeURIComponent(projectId)}`
      ),
    enabled: projectId.length > 0,
  });
